import { HttpErrorCode } from '@copera/common/error';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Doc } from 'src/@types/docs';
import { DocsRequests } from 'src/requests/docs';
import { QueryKey } from 'src/utils/react-query';

export const useDocDuplicateMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: duplicateDoc, isLoading: isDuplicatingDoc } =
    useMutation((docId: string) => DocsRequests.duplicateDoc(docId), {
      meta: {
        httpErrors: {
          [HttpErrorCode.NOT_FOUND]: 'error.docs.document_not_found',
          [HttpErrorCode.FORBIDDEN]: 'error.docs.no_permission_duplicate',
        },
      },
      onSuccess(newContent) {
        queryClient.setQueriesData<Doc[]>([QueryKey.DOCS], (contents) => [
          ...(contents || []),
          newContent,
        ]);
        return newContent;
      },
    });

  return {
    duplicateDoc,
    isDuplicatingDoc,
  };
};
